import { useState } from 'react';
import { Table, TableBody, TableHead, TableRow, IconButton, Chip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ListIcon from '@mui/icons-material/List';
import {
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  NoDataSkeleton,
  ConfirmationDialog,
} from '../../../../common/components';
import { TYPE_LABELS, TYPE_COLORS } from '../constants/taskTemplatesConstants';
import { formatDateForDisplay } from '../utils/taskTemplatesUtils';

/**
 * Componente de tabla de datos para plantillas de tareas
 */
const TaskTemplatesDataTable = ({
  data,
  isLoading,
  onEdit,
  onViewTasks,
  onDelete,
  LoadingComponent,
}) => {
  const [deleteDialog, setDeleteDialog] = useState({
    open: false,
    templateId: null,
    templateInfo: null,
  });

  if (isLoading) {
    return <LoadingComponent />;
  }

  const handleDeleteClick = (template) => {
    setDeleteDialog({
      open: true,
      templateId: template.uuid,
      templateInfo: template,
    });
  };

  const handleDeleteCancel = () => {
    setDeleteDialog({
      open: false,
      templateId: null,
      templateInfo: null,
    });
  };

  const handleDeleteConfirm = () => {
    if (deleteDialog.templateId) {
      onDelete(deleteDialog.templateId);
      handleDeleteCancel();
    }
  };

  return (
    <GeneralTableBox>
      <Table>
        <TableHead>
          <TableRow>
            <HeadTableCell width="25%">Nombre</HeadTableCell>
            <HeadTableCell width="35%" sx={{ display: { xs: 'none', md: 'table-cell' } }}>
              Descripción
            </HeadTableCell>
            <HeadTableCell width="15%">Tipo</HeadTableCell>
            <HeadTableCell width="10%" sx={{ display: { xs: 'none', md: 'table-cell' } }}>
              Tareas
            </HeadTableCell>
            <HeadTableCell width="10%" sx={{ display: { xs: 'none', md: 'table-cell' } }}>
              Creado
            </HeadTableCell>
            <HeadTableCell width="5%">Acciones</HeadTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data && data.length > 0 ? (
            data.map((template) => (
              <TableRow key={template.uuid} hover>
                <RowTableCell>
                  <strong>{template.name}</strong>
                </RowTableCell>
                <RowTableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>
                  {template.description || 'Sin descripción'}
                </RowTableCell>
                <RowTableCell>
                  <Chip
                    label={TYPE_LABELS[template.template_type]}
                    color={TYPE_COLORS[template.template_type]}
                    size="small"
                  />
                </RowTableCell>
                <RowTableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>
                  <Chip
                    label={template.task_count || 0}
                    variant="outlined"
                    size="small"
                    icon={<ListIcon />}
                  />
                </RowTableCell>
                <RowTableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>
                  {formatDateForDisplay(template.created_at)}
                </RowTableCell>
                <RowTableCell>
                  <IconButton
                    size="small"
                    onClick={() => onViewTasks(template)}
                    title="Ver tareas"
                    sx={{ mr: 0.5 }}
                  >
                    <ListIcon fontSize="small" />
                  </IconButton>
                  <IconButton
                    size="small"
                    onClick={() => onEdit(template)}
                    title="Editar plantilla"
                    sx={{ mr: 0.5 }}
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                  <IconButton
                    size="small"
                    onClick={() => handleDeleteClick(template)}
                    title="Eliminar plantilla"
                    color="error"
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </RowTableCell>
              </TableRow>
            ))
          ) : (
            <NoDataSkeleton colSpan={6} message="No hay plantillas de tareas para mostrar" />
          )}
        </TableBody>
      </Table>

      <ConfirmationDialog
        open={deleteDialog.open}
        onClose={handleDeleteCancel}
        onConfirm={handleDeleteConfirm}
        title="Eliminar Plantilla de Tareas"
        message={
          deleteDialog.templateInfo?.task_count > 0
            ? `Esta plantilla tiene ${deleteDialog.templateInfo.task_count} tarea(s) asociada(s). ¿Está seguro que desea eliminar la plantilla "${deleteDialog.templateInfo?.name}"?`
            : `¿Está seguro que desea eliminar la plantilla "${deleteDialog.templateInfo?.name}"?`
        }
        confirmText="Eliminar plantilla"
      />
    </GeneralTableBox>
  );
};

export default TaskTemplatesDataTable;
